import { ValidSkusItem } from '@/src/types/common/stock';
import { ProductItem } from 'src/types/common/product';

export const generateProductSetItem = (product: ProductItem) => {
  const { uuid } = product || {};
  return {
    uuid,
    product: product,
    quantity: 0,
    notes: '',
  };
};

export const generateValidSkuSetItem = (product: ValidSkusItem) => {
  const { uuid } = product || {};
  return {
    uuid,
    product: product,
    quantity: 0,
    notes: '',
  };
};
